
import React from 'react'
import {NodeItem, DagreLink, DagreNode} from './types'
import {ORGS, IOrgs, getOrgInfo} from '../../../../../dict/ORGS'
import {dagreConfig} from './config'

export const chooseName = (id: string ) => id




export const getNodes = (orgs: IOrgs): DagreNode[] => {
    let nodes: DagreNode[] = []
    // id: string,Node[] = []
    // id: string,
    // label: any,
    // class?: string,
    // html?: any,
    // config?: object
    // labelType: 'html' | 'svg' | 'string',
    
    Object.keys(orgs).map(orgID => {
        let {name, fullname, parent_org_id} = orgs[orgID]
        

        let {orgName} = getOrgInfo(orgID)

        let width = orgName.length * 12

        nodes.push({
            id: orgID,
            label: name,
            // label: `<div class="structure-label" id=${orgID} style="min-width: 120px; color: white !important; font-family: Roboto !important">${name}</div>`,
            class: `node`,
            // html: () => <span>html-span</span>,
            config: {
                id: orgID,
                width: width < 80 ? 80 : width,

            },
            // labelType: 'string',
            labelType: 'string',
        })
    })

    return nodes
}














export const getLinks = (orgs: IOrgs): DagreLink[] => {

    const links: DagreLink[] = [];
    // source: any,
    // target: any,
    // class?: string,
    // label?: string, 
    // config?: object
    
    Object.keys(orgs).map(orgID => {
        let {name, fullname, parent_org_id} = orgs[orgID]

        if (parent_org_id && parent_org_id.length){
            links.push({
                source: parent_org_id,
                target: orgID,
                label: '',
                class: 'link',
                config: dagreConfig.edge.organization
            })

        }


    })



    return links
}